import React, { useEffect, useState } from 'react';
import '../LinkPage/LinkPage.css';
import { useSubdomain } from '../../utils/SubdomainUtils';
import { Helmet } from 'react-helmet';

function ErrorPage() {
  const [config, setConfig] = useState(null);

  const namespace = useSubdomain();

  useEffect(() => {
    fetch(`/config/${namespace}/default.json`)
      .then(response => response.json())
      .then((defaultConfig) => setConfig(defaultConfig))
      .catch(error => console.error('Error fetching default config:', error));
  }, []);

  return (
    <div className="error-page">
      <Helmet>
        <meta property='og:title' content="Error - Promopool" />
        <title>Error - Promopool</title>
      </Helmet>
      <div className="container">
        {config &&
        <div className="logo">
          <img src={config.brand.logo} alt={config.brand.name + " logo"} />
        </div>}
        <div className="content">
          <h1>Oops!</h1>
          Page Not Found (404)
        </div>
      </div>
      <div className="footer">
        <span>&copy; {new Date().getFullYear()} {config && config.brand.footer}</span>
      </div>
    </div>
  );
}

export default ErrorPage;
